module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-8@3x.099df56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-8@3x.png
// module id = QEh/
// module chunks = 18